import Phaser from 'phaser'
import Editable from './editable'
import ObstacleEditor from '../editor/obstacleEditor'

const WIDTH = 105
const HEIGHT = 125

export default class Obstacle extends Editable {
  constructor (scene, args, doSave = true) {
    super(scene, args, 'obs', doSave)

    this.bounce = false
    this.lethal = true
    this.height = args.height
    this.easifier = 0

    this.diamondShape = [
      new Phaser.Math.Vector2(0, WIDTH / 2),
      new Phaser.Math.Vector2(WIDTH / 2, 0),
      new Phaser.Math.Vector2(0, -WIDTH / 2),
      new Phaser.Math.Vector2(-WIDTH / 2, 0)]

    this.image = this.scene.matter.add.image(args.x, args.y, 'images', 'spike')
    this.image.setTint(this.scene.colorSpikes)
    this.image.setTrapezoid(WIDTH, HEIGHT, 1)
    this.image.setOrigin(0.5, 0.67)
    this.image.setIgnoreGravity(true)
    this.image.setSensor(true)
    this.image.setDepth(3)
    this.image.parentContainer = this
    this.image.setCollisionGroup(this.scene.collisionGroup1)
    this.image.setCollisionCategory(this.scene.collisionCategory2)

    this.square = this.scene.matter.add.image(args.x, args.y + 45, 'images', 'square')
    this.square.setTint(scene.colorSpikes)
    this.square.setSize(WIDTH, args.height + 10)
    this.square.setDisplaySize(WIDTH, args.height + 10)
    this.square.setIgnoreGravity(true)
    this.square.setSensor(true)
    this.square.setDepth(2)
    this.square.parentContainer = this
    this.square.setCollisionGroup(this.scene.collisionGroup1)
    this.square.setCollisionCategory(this.scene.collisionCategory2)

    this.addEditor(new ObstacleEditor(this.scene, this))

    this.noHeight = args.noHeight || false
    this.addEditableProperty('noHeight', (value) => { this.setNoHeight(value) }, () => { return this.noHeight })

    this.addHiddenProperty('height', () => { return Math.round(this.height) })

    this.init(args, true)
    this.refreshTextures()
    this.refreshSize()
    this.refreshMoving()
    // this.setMoving(this.isMoving)
    // this.onEdit()
  }

  setMoving (value) {
    super.setMoving(value)
    this.refreshTextures()
    this.refreshMoving() // called twice to update the image of the moveComponent properly

    // if (this.isMoving || this.noHeight) {
    //   this.image.setTexture('images', 'diamond')
    //   this.image.setRectangle(WIDTH, WIDTH, { vertices: this.diamondShape })

    //   this.square.setVisible(false)
    //   this.square.setCollisionGroup(this.scene.collisionGroupNO_COLL)
    //   this.square.setCollisionCategory(this.scene.collisionCatNO_COLL)
    // } else {
    //   this.image.setTexture('images', 'spike')
    //   this.image.setTrapezoid(WIDTH, HEIGHT, 1)
    //   this.image.setOrigin(0.5, 0.67)

    //   this.square.setVisible(true)
    //   this.square.setCollisionGroup(this.scene.collisionGroup1)
    //   this.square.setCollisionCategory(this.scene.collisionCategory2)
    // }

    // this.image.setIgnoreGravity(true)
    // this.image.setSensor(true)
    // // this.image.parentContainer = this
    // this.image.setCollisionGroup(this.scene.collisionGroup1)
    // this.image.setCollisionCategory(this.scene.collisionCategory2)
  }

  setNoHeight (value) {
    this.noHeight = value
    this.refreshTextures()
    // this.setMoving(this.isMoving)
  }

  onEdit () {
    super.onEdit()

    this.refreshTextures()
    // this.image.setFlipY(this.height < 0)
    this.refreshPosition()
    this.refreshSize()
  }

  preUpdate (time, delta) {
    super.preUpdate(time, delta)
    this.refreshPosition()
  }

  refreshPosition () {
    this.square.x = this.image.x
    this.square.y = this.image.y + (this.height / 2) + (this.height > 0 ? 45 : -45)
  }

  refreshSize () {
    this.square.setSize(WIDTH, Math.abs(this.height) + 10)
    this.square.setDisplaySize(WIDTH, Math.abs(this.height) + 10)
  }

  refreshTextures () {
    if (this.isMoving || this.noHeight) {
      this.image.setTexture('images', 'diamond')
      this.image.setRectangle(WIDTH, WIDTH, { vertices: this.diamondShape })

      this.square.setVisible(false)
      this.square.setCollisionGroup(this.scene.collisionGroupNO_COLL)
      this.square.setCollisionCategory(this.scene.collisionCatNO_COLL)
    } else {
      this.image.setTexture('images', 'spike')
      if (this.height < 0) {
        this.image.setTrapezoid(WIDTH, -HEIGHT, 1)
        this.image.setOrigin(0.5, 0.33)// 0.67)
        this.image.setFlipY(true)
      } else {
        this.image.setTrapezoid(WIDTH, HEIGHT, 1)
        this.image.setOrigin(0.5, 0.67)
        this.image.setFlipY(false)
      }

      this.square.setVisible(true)
      this.square.setCollisionGroup(this.scene.collisionGroup1)
      this.square.setCollisionCategory(this.scene.collisionCategory2)
    }

    this.image.setIgnoreGravity(true)
    this.image.setSensor(true)
    this.image.setCollisionGroup(this.scene.collisionGroup1)
    this.image.setCollisionCategory(this.scene.collisionCategory2)
  }

  hide () {
    this.image.setVisible(false)
    this.square.setVisible(false)

    this.image.setCollisionGroup(this.scene.collisionGroupNO_COLL)
    this.image.setCollisionCategory(this.scene.collisionCatNO_COLL)
    this.square.setCollisionGroup(this.scene.collisionGroupNO_COLL)
    this.square.setCollisionCategory(this.scene.collisionCatNO_COLL)
  }

  show () {
    this.image.setVisible(true)
    // this.square.setVisible(true)

    this.image.setCollisionGroup(this.scene.collisionGroup1)
    this.image.setCollisionCategory(this.scene.collisionCategory2)
    // this.square.setCollisionGroup(this.scene.collisionGroup1)
    // this.square.setCollisionCategory(this.scene.collisionCategory2)
  }

  makeEasier () {
    if (this.isMoving) {
      // do this:
      // if was below the guide when it got hit{
        // if t was > 1 (moving up){
          // make delay bigger - it needs to wait longer before moving
        // else
          // make the delay smaller - it needs to be further in its tween
      // else
        // if t was > 1 (moving up)
          // make delay smaller
        // else
          // make the delay longer

    } else if (this.noHeight || this.height > 0) {
      this.easifier = 10
    } else {
      this.easifier -= 10
    }
  }

  toDef () {
    const def = super.toDef()
    def.data.y += this.easifier
    return def
  }

  delete () {
    this.square.destroy()
    super.delete()
  }

  // getX () {
  //   return this.triangle.x
  // }

  // getY () {
  //   return this.triangle.y
  // }

  // setX (x) {
  //   this.triangle.x = x
  //   if (this.scene.game.registry.get('selectedAnimal') === SANTA) {
  //     for (var i = 0; i < this.squares.length; i++) {
  //       this.squares[i].x = x
  //     }
  //   } else {
  //     this.square.x = x
  //   }
  // }

  // setY (y) {
  //   y = Math.min(MAX_Y, y)

  //   this.height = y
  //   this.triangle.y = 558 - y
  //   if (this.scene.game.registry.get('selectedAnimal') === SANTA) {
  //     for (var i = 0; i < this.squares.length; i++) {
  //       this.squares[i].y = 558 - y + 93 + (i * (WIDTH - 1))
  //     }
  //   } else {
  //     this.square.y = 558 - y / 2 + 45
  //     this.square.setSize(WIDTH, y + 10)
  //     this.square.setDisplaySize(WIDTH, y + 10)
  //   }
  // }

  // toDef () {
  //   return { x: Math.round(this.triangle.x), t: 'o', c: { h: Math.round(this.height) } }
  // }

  // delete () {
  //   this.triangle.destroy()
  //   if (this.scene.game.registry.get('selectedAnimal') === SANTA) {
  //     // ..
  //   } else {
  //     this.square.destroy()
  //   }
  //   this.destroy()
  //   return this
  // }
}
